import { render, staticRenderFns } from "./tag-management.component.vue?vue&type=template&id=a9e43122&scoped=true"
import script from "./tag-management.component.ts?vue&type=script&lang=ts&external"
export * from "./tag-management.component.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-management.component.vue?vue&type=style&index=0&id=a9e43122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e43122",
  null
  
)

export default component.exports